import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { backButtonHandler } from "../../../Redux/actions";
const GmWelcome = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <div class="section_welcome">
      <div class="widgets_area">
        <div class="d-flex">
          <div class="top-logo">
            <img src="img/green_logo_1.png" />
          </div>
          <div class="middle-sec">
            <div class="welcometable">
              <h4> THANK YOU FOR VERIFYING YOUR EMAIL </h4>
              <h2 class="lg-hd">
                {" "}
                Welcome to the Go<span class="green-txt">GM</span>Go Suite{" "}
              </h2>
            </div>
            <div class="button-sec">
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => dispatch(backButtonHandler("welcome"))}
              >
                Get Started
              </button>
            </div>
          </div>

          <div class="bottom fnb">
            <a href="#_">
              {" "}
              <span class="blue-txt">#</span>
              <span class="dark-green-txt">f&amp;b</span>
              <span class="green-txt">now</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GmWelcome;
